import { isNil } from "lodash";

export function clearString(value: string): string {
  return value == null || value?.trim() == "" ? null : value;
}

// Matches HTML that is effectively "empty" for our use cases:
//  - empty string
//  - <br>, <br/>, <br />
//  - <p></p>
//  - <p><br></p> (incl. optional spaces/self-closing br variants an multiple brs)
//  - stray </p>
// (All after trimming outer whitespace)
export const EMPTY_HTML_REGEX = /^(?:(\s*|<br\s*\/?>|<p>\s*<\/p>|<p>\s*(<br\s*\/?>\s*)*<\/p>|<\/p>))*$/i;

export function clearHTMLString(value: string): string {
  if (isNil(value)) return value;
  const trimmed = value.trim();
  return EMPTY_HTML_REGEX.test(trimmed) ? null : value;
}
